/**
 * 首开进入客户确认前：若 step 3-2 国籍 nationality_code == 1（内地），
 * 先走内地投资者开户声明书页；否则直接进客户确认。
 * 加开流程请勿调用此方法。
 */
export async function resolveCustomerConfirmationPath(apis) {
  const fallback = "/open-account/customerConfirmation";
  try {
    const res = await apis.accountSituationV2({ step_code: "3-2" });
    const configData = res?.process_info?.["3-2"]?.config_data;
    if (!configData) {
      return fallback;
    }
    const parsed =
      typeof configData === "string" ? JSON.parse(configData) : configData;
    if (parsed?.nationality_code == 1) {
      return "/open-account/mainlandInvestorDeclaration";
    }
  } catch (error) {
    console.log("[resolveCustomerConfirmationPath]", error);
  }
  return fallback;
}
